import React, { useContext } from 'react'
import { apiContext } from 'services/ApiContext'
import { useHistory } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { Button } from 'antd'
import localStorage from 'store'

import './style.scss'

const UpgradePremiumButton = () => {
  const { user } = useContext(apiContext)
  const { push, location } = useHistory()

  if (!user || user.group) return null

  return (
    <Button
      className="mr-3 ant-btn-primary"
      onClick={(e) => {
        e.stopPropagation()
        localStorage.set('redirect_after_premium', location.pathname)
        push('/billing')
      }}
    >
      <FormattedMessage id="topBar.menu.upgradePremium" />
      <span className="icm-arrow-up upgrade-btn-text" />
    </Button>
  )
}

export default UpgradePremiumButton
